module.exports = __webpack_public_path__ + "img/link-3.fa4f3250.png";